// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService } from './ApiService';
import { SettingService } from './SettingService';

@Injectable()
export class LocalNetworkService {
    // Api Domain Url
    private apiUrl = '';
    private hostName: string;
    
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }
    
    getLocalNetWork() {
        this.hostName = window.location.hostname;
        if(this.hostName === "auth.aisvietnam.com") {
            const requestUrl = 'http://auth.aisvietnam.com/negotiate';
            return this.apiService.get<any>(requestUrl);
        }
        else {
            const requestUrl = 'http://auth.eca.dev.nascorp.vn/negotiate';
            return this.apiService.get<any>(requestUrl);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/services/LocalNetworkService.ts